import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Supabase URL과 Anon Key가 필요합니다.');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// 인증 관련 타입
export interface Profile {
  id: string;
  email: string;
  full_name: string;
  church_name?: string;
  phone?: string;
  address?: string;
  role: 'member' | 'merchant' | 'supplier' | 'content_supplier' | 'admin';
  avatar_url?: string;
  created_at: string;
  updated_at: string;
}

export interface TalentPoint {
  id: string;
  user_id: string;
  balance: number;
  total_earned: number;
  total_spent: number;
  created_at: string;
  updated_at: string;
}

export interface PointTransaction {
  id: string;
  user_id: string;
  amount: number;
  type: 'earn' | 'spend' | 'exchange' | 'reward';
  description: string;
  reference_type?: 'content' | 'product' | 'donation' | 'community';
  reference_id?: string;
  created_at: string;
}
